/**
 * @description UI Component to display the form item. Underlying it is using the antd form item component.
 *
 * @author  Hemant Kumar Goyal <@hemantkumar.goyal>
 *
 * @reference https://ant.design/components/form#formitem
 *
 * @param {object}  props https://ant.design/components/form#formitem
 *
 * @returns {React.component}
 */

import React from 'react';

import { Form } from 'antd';

const FormItem = (props) => {
	const { children = null, ...restProps } = props;

	return (
		<Form.Item validateFirst {...restProps}>
			{children}
		</Form.Item>
	);
};

export default FormItem;
